import React from 'react'
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import SweetShop from '@/components/outlet/SweetShop';

const sweetShop = () => {
  return (
    <>
      <Head>
        <title>POS Billing Software for Sweet Shops | Best Mithai Shop Billing System</title>
        <link rel="canonical" href="https://queuebuster.co/outlet/sweet-shop-pos-billing-software" />
        <link rel="alternate" href="https://queuebuster.co/outlet/sweet-shop-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="Grow your sweet shop with QueueBuster – the best POS billing software for mithai shops. Fast billing, GST invoices, inventory tracking, and customer loyalty in one app." />
        <meta property="og:title" content="Top POS Billing Software for Sweet Shops | Easy GST Billing & Inventory" />
        <meta property="og:description" content="QueueBuster POS is built for sweet shops and mithai stores. Handle billing, manage stock, track sales, and reward loyal customers – all with one easy-to-use solution." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images-05.png" />
        <meta property="og:url" content="https://queuebuster.co/outlet/sweet-shop-pos-billing-software" />
         <meta property="og:type" content="website" />
      </Head>
         <SchemaTags page="sweet-shop-pos-billing-software" />
      <SweetShop/>
    </>
  )
}
export default sweetShop